import { createAsyncTypes } from 'store/utils';
import { SearchOption } from 'services/configuration';

// State Key
export const KEY = 'willcall';

// Action Types
export const types = {
  GET_ORDER_DETAILS: createAsyncTypes(`${KEY}/GET_ORDER_DETAILS`),
  RESET_WILL_CALL: `${KEY}/RESET_WILL_CALL`,
  RESET_ORDER_DETAILS: `${KEY}/RESET_ORDER_DETAILS`,
  SET_SELECTED_LOOKUP_OPTION: `${KEY}/SET_SELECTED_LOOKUP_OPTION`,
  GET_WILL_CALL_ORDERS: createAsyncTypes(`${KEY}/GET_WILL_CALL_ORDERS`)
};

export interface OrderSeat {
  row: string;
  seat: string;
  section: string;
}

export interface SubOrderLineItem {
  name: string;
  isGA?: boolean;
  sublineItemId: number;
  seatInfo?: OrderSeat[];
  printParams: any;
  isPrinted: boolean;
}

export interface OrderDetail {
  id: string;
  lineItems: OrderLineItem[];
}

export interface OrderLineItem {
  name: string;
  date: string;
  location: string;
  isGA?: boolean;
  isPackage?: boolean;
  subTotal?: number;
  type?: string;
  typeId: number;
  useCompositeTickets?: boolean;
  subOrderLineItems?: SubOrderLineItem[];
}

export interface GetOrderDetailsResponse {
  orders: OrderDetail[];
  customer: {
    name: string;
  };
}

export interface GetOrdersResponse {
  orderSummaries: Order[];
  orders: OrderDetail[];
  customer: {
    name: string;
  };
}

export interface Order {
  orderId: string | number;
  orderDate: string;
  amount: number;
}

export interface WillCallState {
  readonly ordersList: Order[];
  readonly orderDetails: OrderLineItem[];
  readonly customer: {
    readonly name?: string;
  };
  readonly selectedLookupOption?: SearchOption;
  readonly loading: boolean;
  readonly error: undefined | string;
}

export interface GetOrderDetailsAsyncRequest {
  type: typeof types.GET_ORDER_DETAILS.REQUEST;
  payload: {
    orderCode?: string[];
    email?: string;
    orderNumber?: number[];
    // TODO: add phone
  };
}

export interface GetOrderDetailsAsyncError {
  type: typeof types.GET_ORDER_DETAILS.ERROR;
  payload: string;
}

export interface GetOrderDetailsAsyncPending {
  type: typeof types.GET_ORDER_DETAILS.PENDING;
  payload: boolean;
}

export interface GetOrderDetailsAsyncSuccess {
  type: typeof types.GET_ORDER_DETAILS.SUCCESS;
  payload: GetOrderDetailsResponse;
}

export interface ResetWillCall {
  type: typeof types.RESET_WILL_CALL;
}

export interface SetSelectedLookupOption {
  type: typeof types.SET_SELECTED_LOOKUP_OPTION;
  payload: SearchOption;
}

export interface GetOrdersAsyncRequest {
  type: typeof types.GET_WILL_CALL_ORDERS.REQUEST;
  payload: {
    barcode?: string;
    email?: string;
    startDate: string;
  };
}

export interface GetOrdersAsyncError {
  type: typeof types.GET_WILL_CALL_ORDERS.ERROR;
  payload: string;
}

export interface GetOrdersAsyncPending {
  type: typeof types.GET_WILL_CALL_ORDERS.PENDING;
  payload: boolean;
}

export interface GetOrdersAsyncSuccess {
  type: typeof types.GET_WILL_CALL_ORDERS.SUCCESS;
  payload: GetOrdersResponse;
}

export type WillCallActionTypes =
  | GetOrdersAsyncRequest
  | GetOrdersAsyncError
  | GetOrdersAsyncPending
  | GetOrdersAsyncSuccess
  | GetOrderDetailsAsyncRequest
  | GetOrderDetailsAsyncError
  | GetOrderDetailsAsyncPending
  | GetOrderDetailsAsyncSuccess
  | ResetWillCall
  | SetSelectedLookupOption;
